import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
	name: 'dateTime',
})
export class DateTimePipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) return '';

		const dateTime = DateTime.fromISO(value);
		return dateTime.isValid ? dateTime.toFormat('dd/LL/yyyy HH:mm:ss') : '';
	}
}
